import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalsService } from '../libs/globals.service';
import { Sector } from '../models/sector';
import { Sistema } from '../models/sistema';

@Injectable({
  providedIn: 'root'
})
export class ManualService {

  server = GlobalsService.server
  url = this.server + 'api/manual/';

  constructor(private http: HttpClient) { }
  
  getEstado(sistemaID: String): Observable<any> {
    return this.http.get(this.url + "estado/" + sistemaID);
  }

  getSectores(sistemaID: String): Observable<any> {
    return this.http.get(this.url + sistemaID);
  }

  editSistema(id: String, sistema:Sistema): Observable<any> {
    return this.http.post(this.url + id, sistema);
  }

  editSector(sistemaID: String, sector:Sector): Observable<any> {
    return this.http.post(this.url + "sector/" + sistemaID, sector);
  }
}
